import { Stack } from "@mui/material";
import DOMPurify from "dompurify";
import { FC } from "react";
import zoom from "../../../assets/images/zoom.png";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { MuiImage } from "../MuiImage";
import { DefaultStepProps } from "../Stepper/CustomStepper";
import { HeadingL } from "../Typography";
import * as Styled from "./ChangePensionQuestionnaireIntroPage.styled";

export const ChangePensionQuestionnaireIntroPage: FC<DefaultStepProps> = () => {
    const { t } = useTypedTranslation();

    const dirtyInvestmentIntro = t("investmentStrategy.ChangePensionQuestionnaireIntroHtml");
    const cleanInvestmentIntro = DOMPurify.sanitize(dirtyInvestmentIntro, {
        ALLOWED_TAGS: ["strong"],
        ALLOWED_ATTR: [],
    });

    return (
        <Styled.InvestmentStrategyIntroStack>
            <HeadingL>{t("SmartActionsButtons.PensionQuestionnaireTitle")}</HeadingL>
            <Stack spacing={5}>
                <Styled.InvestmentStrategyIntroImageBox>
                    <MuiImage src={zoom} />
                </Styled.InvestmentStrategyIntroImageBox>

                <Styled.InvestmentStrategyIntroBodyTextM
                    component="p"
                    dangerouslySetInnerHTML={{ __html: cleanInvestmentIntro }}
                />
            </Stack>
        </Styled.InvestmentStrategyIntroStack>
    );
};
